import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [{
  path: "/",
  name: "Index",
  component: () => import("../views/Index"),
  meta: { title: '首页' },
  redirect: '/IndexPage',
  children: [{
    path: "/IndexPage",
    name: "IndexPage",
    component: () => import("../views/IndexPage"),
    meta: { title: '首页' },
  },
  {
    path: "/SyncCourses",
    name: "SyncCourses",
    component: () => import("../views/SyncCourses"),
    meta: { title: '同步课程' },
  },
  {
    path: "/About",
    name: "About",
    component: () => import("../views/About"),
    meta: { title: '关于我们' },
  },
  {
    path: "/CoursesDetail",
    name: "CoursesDetail",
    component: () => import("../views/CoursesDetail"),
    meta: { title: '视频详情' },
  },
  //NewsDetail
  {
    path: "/NewsDetail",
    name: "NewsDetail",
    component: () => import("../views/NewsDetail"),
    meta: { title: '新闻详情页' },
  }
  ]
},
];
const router = new VueRouter({
  // mode: "hash",
  // mode: "history",
  base: process.env.BASE_URL,
  routes
});
export default router;
